import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { environment } from 'src/app/core/environments/environment';
import { CSTokenResponse } from '../../models/cstoken-response';
import { AppSessions } from '../../models/app-sessions';

@Injectable({
  providedIn: 'root'
})
export class ControlSystemsService {

  constructor(private readonly http: HttpClient) { }


  postControlSystemsToken(id: string, appId: string, bearerToken: string): Observable<CSTokenResponse> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${bearerToken}`
    });

    return this.http
      .post<CSTokenResponse>(`${environment.engtoolapi}/api/${id}/ControlSystemsApps/${appId}/GetCSAppToken`, {}, { headers })
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getAppSessions(id: string): Observable<AppSessions> {

    return this.http
      .get<AppSessions>(`${environment.engtoolapi}/api/AppSessions/${id}`,)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
        console.error('An error occurred:', error.error.message);
      } else {
        console.error(
          `Backend returned code ${error.status}, ` +
          `body was: ${JSON.stringify(error.error)}, ` +
          `error: ${JSON.stringify(error)}`
        );
      }
    // return an observable with a user-facing error message
    return throwError(
      error);

  }
}
